module.exports = __webpack_public_path__ + "img/msg_img2.b1fa7dfd.jpg";